package ui.campaign.detailv2.editor.feature

import common.frontend.api.Io
import common.frontend.api.Io.Campaign
import io.Repository
import kotlinx.datetime.LocalDate
import kotlin.math.roundToLong

class FeatureCounterSlot(config: Campaign) : FeatureCounter(config) {
    override fun calculateUsage(
        date: LocalDate,
        doyEntry: Io.ListingCampaignDevicesCheck.Entry,
        daySpace: Long,

        companyRepeats: Long,
        companyDuration: Long,

        campaignRepeats: Long,
        campaignDuration: Long
    ): DayInfo {

        val usageNowPct = doyEntry.sum.toFloat() / companyRepeats.toFloat()
        val usageNewPct = campaignRepeats.toFloat() / companyRepeats.toFloat()
        val usageFuturePct = usageNowPct + usageNewPct

        val maxUsage = companyRepeats * companyDuration
        val timeLoops = daySpace.toDouble() / maxUsage.toDouble()

        return DayInfo(
            date = date,
            impressionSum = timeLoops.roundToLong(),
            usageNow = usageNowPct,
            usageFuture = usageFuturePct,
            canBeUsed = usageFuturePct <= 1F,
            inCampaignRange = campaignRepeats > 0
        )
    }

    override suspend fun loadStatesInternal(companyId: Long, campaignId: Long): Io.ListingCampaignDevicesCheck {
        return Repository.api.campaign.devicesCheckSlot(companyId, campaignId)
    }
}